var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angry",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8Zm0,46.774A21.774,21.774,0,1,1,46.774,33,21.8,21.8,0,0,1,25,54.774Zm0-13.71a10.556,10.556,0,0,0-8.125,3.81,1.61,1.61,0,1,0,2.47,2.067,7.584,7.584,0,0,1,11.3,0,1.61,1.61,0,1,0,2.47-2.067A10.52,10.52,0,0,0,25,41.065Zm-4.839-9.677a2.807,2.807,0,0,0-.171-.827.993.993,0,0,0,.171.02A1.615,1.615,0,0,0,21.7,29.431a1.6,1.6,0,0,0-1.079-2.006L12.56,25.006a1.618,1.618,0,0,0-2.006,1.079,1.6,1.6,0,0,0,1.079,2.006l3.125.938a3.219,3.219,0,1,0,5.4,2.359ZM37.44,25.006l-8.065,2.419a1.612,1.612,0,0,0,.464,3.155c.06,0,.111-.02.171-.02a3.259,3.259,0,0,0-.171.827,3.226,3.226,0,1,0,5.393-2.359l3.125-.937a1.609,1.609,0,0,0-.917-3.085Z",
    transform: "translate(0 -8)",
    fill: "#7c98b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.a1a3ec55a6adfa8be5c52aeee486e868.svg";
export { ForwardRef as ReactComponent };